import {Button, Modal, Spin} from "antd";
import {useCallback, useState} from "react";
import {useFetch, useStore} from "@vigo/hooks";
import React from "react";

export const ChangeStatusIntegratorModal = ({integratorId, isActive, setRefetch}) => {
    const [visible, setVisible] = useState();
    const [recall, setRecall] = useState(false);
    const stores = useStore();
    useFetch({
        defaultDataValue: [],
        fetchFn: stores.integratorStore.patchIntegrator.bind(null, {
            integratorId: integratorId,
            isActive: !isActive
        }),
        initialCall: false,
        showLoading: true,
        dependencies: [
            recall
        ],
        callbackFunc: () => {
            setVisible(false);
            setRefetch(prev => !prev);
        }
    });
    const onCancel = useCallback(() => {
        setVisible(false);
    }, []);

    return <div>
        <Modal
            centered
            width={400}
            visible={visible}
            onCancel={onCancel}
            onOk={() => {
                setRecall(prev => !prev);
            }}
            okText={"Evet"}
            cancelText={"Hayır"}
        >
            {
                `${isActive ? "Deaktif" : "Aktif"} Etmek istediğinize emin misiniz`
            }
        </Modal>
        <Button
            size="small"
            type="primary"
            ghost
            onClick={() => setVisible(true)}
        >
           {isActive ? "Deaktif Et" : "Aktif Et"}
        </Button>
    </div>
}